"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeploymentsPersonalisedOutreachService = void 0;
class DeploymentsPersonalisedOutreachService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get the personalised outreach for a deployment
     * @param id
     * @returns DeploymentPersonalisedOutreachResponse
     * @throws ApiError
     */
    getDeploymentPersonalisedOutreach(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/{id}/personalised-outreach',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update the personalised outreach for a deployment
     * @param id
     * @param requestBody
     * @returns DeploymentPersonalisedOutreachResponse
     * @throws ApiError
     */
    updateDeploymentPersonalisedOutreach(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/deployments/{id}/personalised-outreach',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.DeploymentsPersonalisedOutreachService = DeploymentsPersonalisedOutreachService;
